import { useInfiniteQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { UserContext } from "../context/userContext";
import { is401 } from "../../errors/ErrorConstants";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import CustomerReservationsClient from "../../clients/CustomerReservationsClient";

const fetchOrders = async (userCommonId, filters = {}, pageParam = 0) => {
  try {
    return await CustomerReservationsClient.getCustomerOrdersV2(
      userCommonId,
      filters,
      pageParam
    );
  } catch (error) {
    if (is401(error)) {
      AuthenticationFailureHandler.execute();
    }
    return Promise.reject(error);
  }
};

export function useOrders(filters) {
  const { user } = useContext(UserContext);
  const { market, dealerId, salesCode, brand } = user || {};
  const userCommonId = user
    ? `${market}|${dealerId}|${salesCode}|${brand}`
    : null;

  return useInfiniteQuery({
    queryKey: ["orders", userCommonId, filters],
    queryFn: ({ pageParam = 0 }) =>
      fetchOrders(userCommonId, filters, pageParam),
    getNextPageParam: (lastPage) => {
      return lastPage.hasNext ? lastPage.currentPage + 1 : undefined;
    },
    staleTime: 30 * 1000, // Mark data as stale after 30 seconds
    cacheTime: 5 * 60 * 1000, // Keep unused data in cache for 5 minutes
    refetchOnMount: true, // Refetch when component mounts
    refetchOnWindowFocus: true, // Refetch when window regains focus
    retries: 1,
  });
}
